export default __webpack_public_path__ + "static/even@2x-e8abb6dd6bc97f163cf28680aac4cbf5.jpg";